import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36579686"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "columns modal-columns p-0 m-0" }
const _hoisted_2 = {
  class: "column is-8 v-center",
  style: {"position":"relative"}
}
const _hoisted_3 = {
  key: 1,
  class: "tag is-warning float_preview_indicator"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "floatControls" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small floatControlsColor" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "is-clickable fas fa-pen" })
], -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small floatControlsColor" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-times-circle" })
], -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Editing... ")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  class: "m-3",
  style: {}
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "message is-danger" }
const _hoisted_16 = { class: "message-header" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Error", -1))
const _hoisted_18 = { class: "message-body" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { style: {"max-height":"250px","overflow":"scroll","scrollbar-width":"none"} }
const _hoisted_21 = { class: "title pt-1 mb-2" }
const _hoisted_22 = { class: "p-1 mb-2" }
const _hoisted_23 = { class: "is-size-7 pt-1 px-1" }
const _hoisted_24 = { class: "is-clickable" }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "field" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Title", -1))
const _hoisted_29 = { class: "control" }
const _hoisted_30 = { class: "field" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Content", -1))
const _hoisted_32 = { class: "control" }
const _hoisted_33 = ["placeholder"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Media", -1))
const _hoisted_35 = { class: "field" }
const _hoisted_36 = { class: "control file has-name" }
const _hoisted_37 = { class: "file-label" }
const _hoisted_38 = {
  key: 1,
  class: "file-cta",
  style: {"border-right":"none"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "file-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload" })
], -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "file-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" })
], -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = { class: "level" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "level-left",
  style: {"flex-shrink":"1"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "level-item",
    style: {"flex-shrink":"1"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "" }, "Lock for 6 hours")
  ])
], -1))
const _hoisted_46 = {
  class: "level-right",
  style: {"flex-shrink":"1"}
}
const _hoisted_47 = {
  class: "level-item",
  style: {"flex-shrink":"1"}
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-1 icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" })
], -1))
const _hoisted_49 = ["disabled"]
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Post ")
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-1 icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paper-plane" })
], -1))
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "is-pulled-left",
  style: {"height":"100%"}
}, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-pulled-right" }, null, -1))
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "level is-mobile" }
const _hoisted_57 = { class: "level-left" }
const _hoisted_58 = { class: "level-item" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = { class: "level-right" }
const _hoisted_62 = { class: "level-item" }
const _hoisted_63 = { class: "tag is-success is-light is-size-5" }
const _hoisted_64 = { class: "tabs is-fullwidth my-3 pt-1 pb-3" }
const _hoisted_65 = { style: {"border":"none"} }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "is-clickable far fa-heart" })
  ])
], -1))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "is-clickable far fa-comments" })
  ])
], -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "is-clickable fas fa-pen" })
  ])
], -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = {
  key: 0,
  class: ""
}
const _hoisted_73 = {
  key: 1,
  class: ""
}
const _hoisted_74 = {
  key: 2,
  class: "",
  style: {}
}
const _hoisted_75 = { class: "box mb-1 mx-2" }
const _hoisted_76 = { class: "columns" }
const _hoisted_77 = { class: "column is-8" }
const _hoisted_78 = { class: "title is-6 pt-1 mb-0" }
const _hoisted_79 = { class: "is-size-7 pt-1 px-1" }
const _hoisted_80 = { class: "is-clickable" }
const _hoisted_81 = { class: "p-1 mb-2" }
const _hoisted_82 = { class: "column is-4" }
const _hoisted_83 = ["src"]

export function render(_ctx: any,_cache: any) {
  const _component_LockIndicator = _resolveComponent("LockIndicator")!
  const _component_StripePayment = _resolveComponent("StripePayment")!
  const _component_CommentSection = _resolveComponent("CommentSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.post_status == 'locked')
        ? (_openBlock(), _createBlock(_component_LockIndicator, {
            key: 0,
            exp: _ctx.lock_expiration,
            force_expanded: true
          }, null, 8, ["exp"]))
        : _createCommentVNode("", true),
      (_ctx.blobUrl)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "PREVIEW"))
        : _createCommentVNode("", true),
      (_ctx.blobUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            src: _ctx.blobUrl,
            class: "postMedia",
            style: {"max-width":"100%","max-height":"100%","height":"auto","margin-left":"auto","margin-right":"auto"}
          }, null, 8, _hoisted_4))
        : (_openBlock(), _createElementBlock("img", {
            key: 3,
            src: _ctx.post.media,
            class: "postMedia",
            style: {"max-width":"100%","max-height":"100%","height":"auto","margin-left":"auto","margin-right":"auto"}
          }, null, 8, _hoisted_5)),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.modalSelection!='edit')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "has-text-white is-clickable",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.click_edit && _ctx.click_edit(...args)))
            }, _hoisted_9))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "has-text-white is-clickable",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.click_comments && _ctx.click_comments(...args)))
            }, _hoisted_12))
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass('column is-4 modal-right p-0  ' + (_ctx.isMobile ? '' : 'post_history'))
    }, [
      _createElementVNode("div", _hoisted_13, [
        (_ctx.postError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("article", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.postError = '')),
                    class: "delete",
                    "aria-label": "delete"
                  })
                ]),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.postError), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.modalSelection != 'edit')
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.post.title), 1),
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.post.content), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("b", _hoisted_24, _toDisplayString(_ctx.post.authorusername), 1),
                _createTextVNode(" - " + _toDisplayString(_ctx.postTime), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.modalSelection == 'edit')
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              (!_ctx.showPayment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("fieldset", null, [
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("div", _hoisted_29, [
                          _withDirectives(_createElementVNode("input", {
                            class: "input is-disabled",
                            type: "text",
                            placeholder: 'Title',
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editing_title) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.editing_title]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("div", _hoisted_32, [
                          _withDirectives(_createElementVNode("textarea", {
                            class: "textarea",
                            placeholder: 'Content...',
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editing_content) = $event))
                          }, null, 8, _hoisted_33), [
                            [_vModelText, _ctx.editing_content]
                          ])
                        ])
                      ]),
                      _hoisted_34,
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("label", _hoisted_37, [
                            (!_ctx.blobUrl)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.previewFiles && _ctx.previewFiles(...args))),
                                  class: "file-input",
                                  type: "file",
                                  name: "resume",
                                  accept: "image/*"
                                }, null, 32))
                              : _createCommentVNode("", true),
                            (!_ctx.blobUrl)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, _hoisted_40))
                              : (_openBlock(), _createElementBlock("span", {
                                  key: 2,
                                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clear_blob && _ctx.clear_blob(...args))),
                                  class: "file-cta",
                                  style: {"border-right":"none"}
                                }, _hoisted_42))
                          ]),
                          (_ctx.blobUrl)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                class: "has-text-left input",
                                style: {"border-left":"none"},
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.mediaEditingUrl) = $event)),
                                placeholder: '',
                                disabled: ""
                              }, null, 512)), [
                                [_vModelText, _ctx.mediaEditingUrl]
                              ])
                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 1,
                                class: "has-text-left input",
                                style: {"border-left":"none"},
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editing_media) = $event)),
                                placeholder: 'upload a file, or paste a link'
                              }, null, 512)), [
                                [_vModelText, _ctx.editing_media]
                              ])
                        ])
                      ]),
                      _hoisted_43,
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("button", {
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.lock_post && _ctx.lock_post(...args))),
                              class: "m-1 button is-warning"
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.lock_cost) + " ", 1),
                              _hoisted_48
                            ]),
                            _createElementVNode("button", {
                              disabled: _ctx.post_status == 'locked',
                              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.save_edit && _ctx.save_edit(...args))),
                              class: "m-1 button is-success"
                            }, _hoisted_52, 8, _hoisted_49)
                          ])
                        ])
                      ]),
                      _hoisted_53,
                      _hoisted_54
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", {
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.cancelPayment())),
                            class: "button"
                          }, _hoisted_60)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("span", _hoisted_63, "6 hours - " + _toDisplayString(_ctx.lock_cost), 1)
                        ])
                      ])
                    ]),
                    _createVNode(_component_StripePayment, {
                      onMount: _ctx.stripeMount,
                      blobHash: _ctx.blobHash,
                      post: _ctx.updated_post
                    }, null, 8, ["onMount", "blobHash", "post"])
                  ]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_64, [
        _createElementVNode("ul", _hoisted_65, [
          _createElementVNode("li", {
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.click_likes && _ctx.click_likes(...args))),
            class: _normalizeClass({ 'is-active': _ctx.modalSelection == 'like' })
          }, _hoisted_67, 2),
          _createElementVNode("li", {
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.click_comments && _ctx.click_comments(...args))),
            class: _normalizeClass({ 'is-active': _ctx.modalSelection == 'comment' })
          }, _hoisted_69, 2),
          _createElementVNode("li", {
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.click_edit && _ctx.click_edit(...args))),
            class: _normalizeClass({ 'is-active': _ctx.modalSelection == 'edit' })
          }, _hoisted_71, 2)
        ])
      ]),
      (_ctx.modalSelection == 'like')
        ? (_openBlock(), _createElementBlock("div", _hoisted_72, " likes... coming soon "))
        : _createCommentVNode("", true),
      (_ctx.modalSelection == 'comment')
        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
            _createVNode(_component_CommentSection, { slot: _ctx.slot }, null, 8, ["slot"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.modalSelection == 'edit')
        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.post_history, (p, index) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, _toDisplayString(p.title), 1),
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("b", _hoisted_80, _toDisplayString(p.authorusername), 1),
                        _createTextVNode(" - " + _toDisplayString(_ctx.ago(p.post_time)) + " ", 1),
                        _createElementVNode("div", _hoisted_81, _toDisplayString(p.content), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("img", {
                        alt: "media",
                        src: p.media,
                        style: {"width":"auto","height":"70px"}
                      }, null, 8, _hoisted_83)
                    ])
                  ])
                ])
              ]))
            }), 256))
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}